<template>
  <div>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense v-if="!dataReady">
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>

              <v-col cols="12">
                <v-sheet tile height="54" class="d-flex">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                    label="เดือน"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปี"
                    class="ma-2"
                  ></v-select>
                  <v-icon color="#871B12" size="30" @click="getData()"
                    >mdi-calendar-search</v-icon
                  >
                </v-sheet>
              </v-col>
            </v-card>
            <v-tabs v-model="tabs" fixed-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#info" class="primary--text"> ข้อมูล </v-tab>

              <v-tab href="#summaryReport" class="primary--text">
                ประวัติ
              </v-tab>
              <v-tab
                v-if="profile.positionLevelOrderNumber > 1"
                href="#request"
                @click="getDataRequest('draft')"
                class="primary--text"
              >
                คำขอ
                <v-badge
                  v-if="dataCountItemDraft > 0"
                  color="red"
                  :content="dataCountItemDraft"
                >
                </v-badge>
              </v-tab>
              <v-tab
               v-if="profile.positionLevelOrderNumber > 1"
                href="#Verify"
                @click="getDataRequest('verify')"
                class="primary--text"
              >
                รับทราบ
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item value="info">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr style="background-color: #1b437c">
                        <th class="text-center">วัน</th>
                        <th class="text-center">เข้างาน</th>
                        <th class="text-center">เลิกงาน</th>
                        <th class="text-center">AC</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(items, index) in shifttem" :key="index">
                        <td>
                          {{ items.shiftDay }}
                        </td>
                        <td>
                          <v-chip
                            class="ma-2"
                            :color="items.colorin"
                            text-color="white"
                          >
                            {{ items.checkInStartStamp }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip
                            class="ma-2"
                            :color="items.colorout"
                            text-color="white"
                          >
                            {{ items.checkInEndStamp }}
                          </v-chip>
                        </td>
                        <td>
                          <div class="text-center">
                            <!-- {{items.reqeustAdjustStatus}} -->
                            <!-- {{items.lateStatus}}
                            {{items.checkInEndStamp}}
                            {{items.checkInStartStamp}} -->
                            <v-btn v-if="items.reqeustAdjustStatus">
                              <label
                                v-if="items.reqeustAdjustStatus === 'draft'"
                                >รออนุมัติ</label
                              >
                              <label
                                v-if="items.reqeustAdjustStatus === 'approve'"
                                >อนุมัติ</label
                              >
                              <label
                                v-if="items.reqeustAdjustStatus === 'unapprove'"
                                >ไม่อนุมัติ</label
                              >
                            </v-btn>
                            <v-btn
                              v-if="
                                adjustINAll < 2 &&
                                items.reqeustAdjustIN &&
                                items.leaveSummaryDayName != 'ครึ่งวันเช้า' &&
                                items.checkBeforeMonth &&
                                items.shiftDate < currentMorDay
                              "
                              color="orange"
                              dark
                              @click="
                                (dialogForm = true),
                                  itemData(items),
                                  validate('ADD')
                              "
                            >
                              ใช้สิทธ์ IN
                            </v-btn>
                            <v-btn
                              v-if="
                                adjustOUTAll < 2 &&
                                items.reqeustAdjustOUT &&
                                items.leaveSummaryDayName != 'ครึ่งวันบ่าย' &&
                                items.checkBeforeMonth &&
                                items.shiftDate < currentMorDay
                              "
                              color="orange"
                              dark
                              @click="
                                (dialogForm = true),
                                  itemData(items),
                                  validate('ADD')
                              "
                            >
                              ใช้สิทธ์ OUT
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
              <v-tab-item value="summaryReport">
                <v-card>
                  <v-col cols="12">
                    <br />
                    <v-card
                      elevation="10"
                      v-for="(items, index) in dataItem"
                      :key="index"
                      class="ma-2 pa-2"
                    >
                      <v-card-actions class="ma-0 pa-0">
                        <v-btn v-if="items.status == 'draft'" color="blue" text>
                          หัวหน้าตรวจสอบ
                        </v-btn>

                        <v-btn
                          v-if="items.status == 'approve'"
                          color="green"
                          text
                        >
                          อนุมัติ
                        </v-btn>

                        <v-btn
                          v-if="items.status == 'unapprove'"
                          color="red"
                          text
                        >
                          รายการถูกยกเลิก
                        </v-btn>
                      </v-card-actions>
                      <v-row>
                        <v-col cols="2" class="pa-2 ml-5 mt-5">
                          <v-img :src="require('@/assets/noOut.png')"></v-img>
                        </v-col>
                        <v-col class="ml-0 mb-0 pa-0">
                          <v-card-text
                            class="text-left"
                            v-if="items.adjustRequest === 'IN'"
                          >
                            <strong
                              >วันที่: {{ items.adjust_day }}-{{
                                items.adjust_month
                              }}-{{ items.adjust_year }}</strong
                            ><br />
                            เวลาเช้า: {{ items.shift_check_in }} -
                            {{ items.check_out }}
                            <v-chip
                              class="text-right ml-2"
                              color="red"
                              dark
                              small
                            >
                              {{ items.lateStatus }} </v-chip
                            ><br />
                            <v-chip
                              class="text-center"
                              color="blue darken-3"
                              dark
                              >ขอแก้ไขเวลาเข้างาน </v-chip
                            ><br />
                          </v-card-text>
                          <v-card-text
                            class="text-left"
                            v-if="items.adjustRequest === 'OUT'"
                          >
                            <strong
                              >วันที่: {{ items.adjust_day }}-{{
                                items.adjust_month
                              }}-{{ items.adjust_year }}</strong
                            ><br />
                            เวลาเย็น: {{ items.shift_check_out }} -
                            ไม่พบข้อมูล<br />
                            <v-chip
                              class="text-center"
                              color="orange darken-3"
                              dark
                              >ขอแก้ไขเวลาออกงาน </v-chip
                            ><br />
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-card>
              </v-tab-item>
              <v-tab-item value="request">
                <v-card>
                  <v-tabs v-model="tabsHeaer" fixed-tabs>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      id="request_waiting"
                      href="#request_waiting"
                      class="primary--text"
                    >
                      <v-icon>mdi-clock</v-icon>รออนุมัติ
                    </v-tab>
                    <v-tab
                      @click="getDataRequest('header')"
                      id="approve_history"
                      href="#approve_history"
                      class="primary--text"
                    >
                      <v-icon>mdi-file-document</v-icon>ประวัติ
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tabsHeaer">
                    <v-tab-item value="request_waiting">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">รายละเอียด</th>
                              <th class="text-center">สถานะ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dataItemDraft"
                              :key="item.adjustID"
                            >
                              <td>
                                ผู้ขอ : {{ item.empFull_NameTH }}<br />
                                ประเภทการแก้ไข:
                                <strong v-if="item.adjust_type_mode == 'LATE'"
                                  >NO IN</strong
                                ><strong
                                  v-if="item.adjust_type_mode == 'NO_OUT'"
                                  >NO OUT</strong
                                ><br />
                                วันที่ : {{ item.adjust_date }} <br />
                              </td>
                              <td>
                                <v-btn
                                  v-if="item.status == 'draft'"
                                  color="red"
                                  class="ma-2"
                                  small
                                  dark
                                  @click="getInfo(item)"
                                >
                                  <v-icon>mdi-alert</v-icon> จัดการ
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-tab-item>
                    <v-tab-item value="approve_history">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">รายละเอียด</th>
                              <th class="text-center">สถานะ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in dataItem" :key="item.adjustID">
                              <td>
                                ผู้ขอ : {{ item.empFull_NameTH }}<br />
                                ประเภทการแก้ไข : <strong v-if="item.adjust_type_mode == 'LATE'"
                                  >NO IN</strong
                                ><strong
                                  v-if="item.adjust_type_mode == 'NO_OUT'"
                                  >NO OUT</strong
                                ><br />
                                วันที่: {{ item.adjust_date }}
                              </td>
                              <td>
                                <v-btn
                                  v-if="item.status == 'draft'"
                                  color="amber"
                                  small
                                  dark
                                  elevation="2"
                                >
                                  รออนุมัติ
                                </v-btn>
                                <v-btn
                                  v-if="item.status == 'approve'"
                                  color="green"
                                  small
                                  dark
                                  elevation="2"
                                >
                                  อนุมัติ
                                </v-btn>
                                <v-btn
                                  v-if="item.status == 'unapprove'"
                                  dark
                                  color="red"
                                  small
                                  elevation="2"
                                >
                                  ไม่อนุมัติ
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-tab-item>
              <v-tab-item value="Verify">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr style="background-color: #1b437c">
                        <th class="text-center">รายละเอียด</th>
                        <th class="text-center">สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in dataItemVerifyApprove"
                        :key="item.adjustID"
                      >
                        <td>
                          ผู้ขอ : {{ item.empFull_NameTH }}<br />
                          ประเภทการแก้ไข : <strong v-if="item.adjust_type_mode == 'LATE'"
                                  >NO IN</strong
                                ><strong
                                  v-if="item.adjust_type_mode == 'NO_OUT'"
                                  >NO OUT</strong
                                ><br />
                          วันที่: {{ item.adjust_date }}
                        </td>
                        <td>
                          <v-btn
                            v-if="item.status == 'draft'"
                            color="amber"
                            small
                            dark
                            elevation="2"
                          >
                            รออนุมัติ
                          </v-btn>
                          <v-btn
                            v-if="item.status == 'approve'"
                            color="green"
                            small
                            dark
                            elevation="2"
                          >
                            อนุมัติ
                          </v-btn>
                          <v-btn
                            v-if="item.status == 'unapprove'"
                            dark
                            color="red"
                            small
                            elevation="2"
                          >
                            ไม่อนุมัติ
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs-items>
            <p></p>
            <v-dialog v-model="dialogForm" fullscreen>
              <v-toolbar color="indigo" dark>
                <v-toolbar-title>ขอแก้ไขเวลาเข้า-ออก งาน</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="getData(), (dialogForm = false)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card>
                <v-card>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr style="background-color: #1b437c">
                          <th class="text-left">รายการ</th>
                          <th class="text-left">รายละเอียด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>วันที่</td>
                          <td>{{ item_data.masShiftTypeNameDay }}</td>
                        </tr>
                        <tr>
                          <td>ประเภทกะ</td>
                          <td>{{ item_data.masShiftTypeName }}</td>
                        </tr>
                        <tr>
                          <td>เวลาเข้างาน</td>
                          <td>
                            {{ item_data.checkInStamp }}
                            {{ item_data.lateStatus }} ({{
                              item_data.lateTime
                            }})
                          </td>
                        </tr>
                        <tr>
                          <td>เวลาเลิกงาน</td>
                          <td>{{ item_data.checkInEndStamp }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>

                <v-divider style="background-color: #ffffff"></v-divider>
                <v-form ref="form_add" v-model="valid_add" lazy-validation>
                  <v-card-text class="pa-2 ma-2" cols="12">
                    <v-col cols="12">
                      <h6 :class="` font-weight-bold grey--text pb-5`">
                        เลือก ประเภทการแก้ไขเวลาเข้า-ออก งาน
                      </h6>
                      <v-select
                        v-model="formRequest.adjustRequest"
                        :items="itemsAdjustQuota"
                        :rules="nameRules"
                        prepend-icon="mdi-table-edit"
                        clearable
                        disabled
                        clear-icon="mdi-close-circle"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                  </v-card-text>

                  <v-divider style="background-color: #ffffff"></v-divider>
                  <v-col cols="12">
                    <v-card-text class="pa-2 ma-2">
                      <v-textarea
                        maxlength="100"
                        rows="3"
                        row-height="25"
                        outlined
                        v-model="formRequest.adjustRemark"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="หมายเหตุ"
                        :rules="nameRules"
                      ></v-textarea>
                    </v-card-text>
                  </v-col>
                </v-form>

                <v-card-actions>
                  <v-col class="text-center pt-0 pb-10">
                    <v-btn
                      color="success"
                      elevation="2"
                      dark
                      :disabled="!valid_add"
                      @click="
                        sendRequestAdjust(formRequest, item_data)
                      "
                    >
                      ส่งคำขอ
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogApprove">
              <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                  <v-col class="text-right pb-0 pt-0 pr-0">
                    <v-icon color="#173053" @click="dialogApprove = false"
                      >mdi-close-circle</v-icon
                    >
                  </v-col>
                </v-card-title>
                <v-card-title class="pa-0 ml-6 mb-2">
                  <span class="headline">หมายเหตุ</span>
                </v-card-title>
                <v-card-text class="pa-4 pb-0">
                  <v-textarea
                    v-model="formUpdate.adjustRemarkHeader"
                    maxlength="100"
                    rows="3"
                    row-height="25"
                    outlined
                    :rules="nameRules"
                    clearable
                    clear-icon="mdi-close-circle"
                    label="หมายเหตุ"
                  ></v-textarea>
                </v-card-text>
                <v-card-actions class="pa-2 ma-2 mt-0">
                  <v-btn
                    color="red"
                    elevation="2"
                    dark
                    @click="updateAdjust(formUpdate, 'unapprove')"
                  >
                    ไม่อนุมัติ
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="success"
                    elevation="2"
                    dark
                    @click="updateAdjust(formUpdate, 'approve')"
                  >
                    อนุมัติ
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// moment().format('YYYY')
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
export default {
  // name: 'Adjust Check IN-OUT',
  data () {
    return {
      dataReady: false,
      shifttem: [],
      formUpdate: [],
      dataItem: [],
      dataItemDraft: [],
      dataItemHeaderApprove: [],
      dataItemVerifyApprove: [],
      dataCountItemDraft: 0,
      year: '',
      month: '',
      day: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      tabs: 'tabInfo',
      tabsHeaer: 'request_waiting',
      profile: [],
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      dialogForm: false,
      dialogApprove: false,
      currentMorDay: '',
      itemsAdjustQuota: ['IN', 'OUT'],
      formRequest: [],
      nameRules: [(v) => !!v || 'Input is required'],
      valid_add: true,
      adjustINAll: 0,
      adjustOUTAll: 0
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.currentMorDay = moment().add('days').format('YYYY-MM-DD')
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getData () {
      this.formRequest.adjustRemark = null
      await this.getHistoryNoINOUT()
      // await this.getDataRequest('empCode')
      await this.shift_import()
      this.getEmployeeApprovePermission()
      if (this.profile.positionLevelOrderNumber > 1) {
        this.getDataRequest('draft')
        this.getDataRequest('header')
        this.getDataRequest('verify')
      }
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
      }
    },
    getInfo (item) {
      this.formUpdate = []
      this.dialogApprove = true
      this.formUpdate = item
      this.formUpdate.adjustRemarkHeader = '-'
    },
    async getHistoryNoINOUT () {
      this.dataItem = []
      var dataItem = await axios.get(
        // eslint-disable-next-line quotes
        this.DNS_IP +
          '/adjust_request/get?adjust_month=' +
          this.getMonthThToINT(this.month) +
          '&adjust_year=' +
          this.year +
          '&empCode=' +
          this.profile.empCode,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
      if (dataItem) {
        this.dataItem = dataItem.data
      }
    },
    async shift_import () {
      this.dataReady = false

      this.month = this.month !== '' ? this.month : this.getMonthTh()
      this.year = this.year !== '' ? this.year : moment().format('YYYY')

      this.currentMonth = moment().format('M')

      var currentDate = moment().format('YYYY-MM-DD')
      var currentThreeTHDate =
        moment().format('YYYY') + '-' + moment().format('MM') + '-05'
      var convertThreeTHDate = moment(currentThreeTHDate).format('YYYY-MM-DD')
      this.shifttem = []
      var adjustIN = 0
      var adjustOUT = 0
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getEmpCodeShiftMonth?empCode=' +
            this.profile.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          this.dataReady = false
          this.shifttem = response.data
          this.shifttem.forEach((shifttem) => {
            shifttem.reqeustAdjust = false
            const adjustResult = this.dataItem
              ? this.dataItem.filter(
                (io) => {
                  return io.adjust_year === shifttem.shiftYear &&
                    io.adjust_month === shifttem.shiftMonth &&
                    io.adjust_day === shifttem.shiftDay &&
                    io.status !== 'unapprove'
                })
              : (this.dataItem = [])

            shifttem.reqeustAdjustStatus =
              adjustResult.length > 0 ? adjustResult[0].status : null
            shifttem.adjustRequest =
              adjustResult.length > 0 ? adjustResult[0].adjustRequest : null

            if (shifttem.adjustRequest) {
              if (shifttem.adjustRequest === 'IN') {
                adjustIN = adjustIN + 1
              }
              if (shifttem.adjustRequest === 'OUT') {
                adjustOUT = adjustOUT + 1
              }
            }

            shifttem.adjustIN = typeof adjustIN !== 'undefined' ? adjustIN : 0
            shifttem.adjustOUT =
              typeof adjustOUT !== 'undefined' ? adjustOUT : 0

            if (shifttem.checkInStartStamp) {
              shifttem.colorout = 'green'

              if (shifttem.lateStatus === 'ปกติ') {
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
                shifttem.reqeustAdjustIN = shifttem.adjustIN < 2 && adjustResult.length < 1
                shifttem.reqeustAdjust = 'IN'
              }

              if (!shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
                shifttem.reqeustAdjustOUT = shifttem.adjustOUT < 2 && adjustResult.length < 1
                shifttem.reqeustAdjustIN = false
                shifttem.reqeustAdjust = 'OUT'
              }
              shifttem.checkBeforeMonth = true
              if (shifttem.shiftMonth < this.currentMonth) {
                if (currentDate > convertThreeTHDate) {
                  shifttem.checkBeforeMonth = false
                }
              }

              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
              }
              if (shifttem.leave !== null) {
                shifttem.detail = shifttem.leave
                shifttem.checkInStartStamp =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? shifttem.leave
                    : shifttem.checkInStartStamp
                shifttem.checkInEndStamp =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? shifttem.leave
                    : shifttem.checkInEndStamp
                shifttem.colorin =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? 'blue'
                    : shifttem.colorin
                shifttem.colorout =
                  shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                  shifttem.leaveSummaryDayName === 'เต็มวัน'
                    ? 'blue'
                    : shifttem.colorout
              }
            } else {
              if (shifttem.shiftCode === 'H') {
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.detail = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                if (shifttem.leave !== null) {
                  shifttem.detail = shifttem.leave
                  shifttem.checkInStartStamp =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? shifttem.leave
                      : 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? shifttem.leave
                      : 'ไม่พบข้อมูล'
                  shifttem.colorin =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? 'blue'
                      : '-'
                  shifttem.colorout =
                    shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' ||
                    shifttem.leaveSummaryDayName === 'เต็มวัน'
                      ? 'blue'
                      : '-'
                } else {
                  shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                }
              }
            }
          })
          this.shifttem = this.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          this.adjustINAll = adjustIN
          this.adjustOUTAll = adjustOUT
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
        })
    },
    async getDataRequest (status) {
      var dataItem
      switch (status) {
        case 'empCode':
          this.dataItem = []
          dataItem = await this.requestAPI('&empCode=' + this.profile.empCode)
          this.dataItem = dataItem.length > 0 ? dataItem : []
          break

        case 'draft':
          this.dataItemDraft = []
          this.dataCountItemDraft = 0
          dataItem = await this.requestAPI('&status=draft&empCodeApprove=' + this.profile.empCode)
          if (dataItem.length > 0) {
            this.dataItemDraft = dataItem
            this.dataCountItemDraft = dataItem.length
            this.tabs = 'request'
          }

          break
        case 'header':
          this.dataItemHeaderApprove = []
          dataItem = await this.requestAPI('&empCodeApprove=' + this.profile.empCode)
          this.dataItemHeaderApprove = dataItem.length > 0 ? dataItem : []
          break
        case 'verify':
          this.dataItemVerifyApprove = []
          dataItem = await this.requestAPI('&empCodeVerify=' + this.profile.empCode)
          this.dataItemVerifyApprove = dataItem.length > 0 ? dataItem : []
          break
      }
    },
    async requestAPI (url) {
      const dataItem = await axios.get(
        this.DNS_IP +
          '/adjust_request/get?adjust_year=' +
          this.year +
          '&adjust_month=' +
          this.getMonthThToINT(this.month) +
          url,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
      return dataItem.data ? dataItem.data : []
    },
    async itemData (item) {
      this.item_data = item
      this.item_data.masShiftTypeNameDay =
        item.shiftDay + ' ' + this.month + ' ' + this.year
      this.formRequest.adjustRequest = item.reqeustAdjust
    },
    async getEmployeeApprovePermission () {
      await axios
        .get(
          this.DNS_IP +
            '/approve_permission/get?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.profile.userLineuserId_approve =
            response.data[0].userLineuserId_approve
          this.profile.userLineuserId_verify =
            response.data[0].userLineuserId_verify
        })
    },
    async sendRequestAdjust (dt, item) {
      let form = {
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName,
        empCode: this.profile.empCode,
        shiftCode: item.shiftCode,
        shift_check_in: item.masShiftTypeStartTime,
        check_in: item.checkInStamp,
        shift_check_out: item.masShiftTypeEndTime,
        check_out: item.checkOutStamp,
        adjust_year: item.shiftYear,
        adjust_month: item.shiftMonth,
        adjust_day: item.shiftDay,
        adjust_date: item.shiftDate,
        status: 'draft',
        adjustRemark: dt.adjustRemark,
        adjustRequest: dt.adjustRequest
      }
      this.dataReady = true
      // this.$swal({
      //   title: 'ต้องการ ส่งคำขอแก้ไข ใช่หรือไม่?',
      //   type: 'question',
      //   showCancelButton: true,
      //   confirmButtonColor: '#43A047',
      //   cancelButtonColor: '#b3b1ab',
      //   confirmButtonText: 'ใช่',
      //   cancelButtonText: 'ไม่'
      // }).then(async (result) => {

      try {
        let userLineuserIdApprove = this.profile.userLineuserId_approve
        let empFullNameTH = this.profile.empFull_NameTH
        await axios
          .post(this.DNS_IP + '/adjust_request/add', form)
          .then(async (response) => {
            alert('ส่งข้อมูลเรียบร้อย')
            this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
            this.dataReady = true
            this.dialogForm = false
            await this.sendLineRequetAdustLiffSendMessage(form, empFullNameTH, userLineuserIdApprove)
            await this.getData()
          })
      } catch (error) {
        alert('Error Adjust :', error)
      }

      // }).catch((error) => {
      //   console.log('error approve : ', error)
      //   this.dataReady = false
      // })
    },
    async updateAdjust (dt, status) {
      this.dataReady = true

      this.$swal({
        title: 'ต้องการ ' + status + 'ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#43A047',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            status: status,
            adjustRemarkHeader: dt.adjustRemarkHeader,
            LAST_USER: this.profile.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/adjust_request/edit/" + dt.adjustID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.dialogApprove = false
              this.dataReady = false
              if (status === 'approve') {
                await this.updateCheckINOUT(dt)
              }
              let form = {
                adjust_date: dt.adjust_date,
                adjustRequest: dt.adjustRequest,
                status: status,
                adjustRemark: dt.adjustRemark
              }
              await this.sendLineRequetAdustLiffSendMessage(
                form,
                dt.empFull_NameTH,
                dt.userLineuserId
              )
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = false
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)
          this.dataReady = false
        })
    },
    async sendLineRequetAdustLiffSendMessage (data, empName, userLineId) {
      var statusName = ''
      var color = ''
      var imageUrl = ''
      switch (data.status) {
        case 'draft':
          statusName = 'รออนุมัติ'
          color = 'FFC107'
          imageUrl =
            'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fadjust%2FAdjust_Draft.png?alt=media&token=91b45ce6-271d-48e0-a3a6-a87f4c2fb22b'
          break
        case 'approve':
          statusName = 'อนุมัติ'
          color = '0d6e00'
          imageUrl =
            'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fadjust%2FAdjust_Approve.png?alt=media&token=13d450a9-f731-41a6-bb99-9eb7c6d5bab3'

          break
        case 'unapprove':
          statusName = 'ไม่อนุมัติ'
          color = '800311'
          imageUrl =
            'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fadjust%2FAdjust_Unapprove.png?alt=media&token=91999712-d66b-4b9d-87e3-d96044b01bc0'

          break
        default:
          break
      }

      var configMessgae = {
        empFull_NameTH: empName,
        statusReuest: statusName,
        adjustRequest: data.adjustRequest,
        adjust_date: data.adjust_date,
        imageAdjustUrl: imageUrl
      }

      const payload = []
      payload.push({
        type: 'flex',
        altText:
          configMessgae.empFull_NameTH +
          '[ขออนุมัติ No Check ' +
          configMessgae.adjustRequest +
          ']',
        contents: {
          type: 'bubble',
          size: 'giga',
          body: {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'image',
                url: configMessgae.imageAdjustUrl,
                size: '60%',
                gravity: 'center'
              }
            ],
            paddingAll: '0px',
            offsetTop: 'md'
          },
          footer: {
            type: 'box',
            layout: 'vertical',
            contents: [
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'text',
                    text: 'คำร้องขอ  No Check ' + configMessgae.adjustRequest,
                    wrap: true,
                    align: 'center'
                  },
                  {
                    type: 'text',
                    text: configMessgae.statusReuest,
                    wrap: true,
                    align: 'center',
                    size: '26px',
                    color: '#' + color,
                    weight: 'regular',
                    style: 'normal',
                    decoration: 'none'
                  }
                ],
                margin: '10px'
              },
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'text',
                    text: configMessgae.empFull_NameTH,
                    wrap: true,
                    align: 'center'
                  },
                  {
                    type: 'text',
                    text: 'วันที่ขอแก้ไข ' + configMessgae.adjust_date,
                    wrap: true,
                    align: 'center'
                  },
                  {
                    type: 'text',
                    text:
                      'วันที่ทำรายการ ' +
                      moment().format('YYYY-MM-DD HH:mm:ss'),
                    wrap: true,
                    align: 'center'
                  }
                ],
                margin: '10px'
              },
              {
                type: 'button',
                action: {
                  type: 'uri',
                  label: 'ตรวจสอบประวัติ',
                  uri: 'line://app/1654154168-JML0KbN5?page=AdjustCheckInCheckOut'
                },
                style: 'secondary',
                margin: '10px',
                adjustMode: 'shrink-to-fit'
              }
            ]
          }
        }
      })
      this.sendLIFFMessage(payload)
      this.sendPushMessage(payload, userLineId)
    },
    async sendLIFFMessage (payload) {
      if (
        this.$liff.getContext().type !== 'none' &&
        this.$liff.getContext().type !== 'external'
      ) {
        await this.$liff.sendMessages(payload)
      }
    },
    async sendPushMessage (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios.post(this.DNS_IP + '/line/push_message', dt, {
        headers: {
          'Application-Key': localStorage.getItem('ApplicationKey')
        }
      })
    },
    async updateCheckINOUT (item) {
      let ds = {}
      ds.adjustStatus = item.adjustRequest
      if (item.adjustRequest === 'OUT') {
        ds.checkInEndStamp = item.shift_check_out
        ds.earlyTime = '00:00'
        ds.earlyStatus = 'ปกติ'
        ds.endDate = item.shift_check_out
      } else if (item.adjustRequest === 'IN') {
        ds.checkInStartStamp = item.shift_check_in
        ds.lateStatus = 'ปกติ'
        ds.lateTime = '00:00'
      }

      await axios.post(
        this.DNS_IP + '/ch_checkin/adjust_edit/' + item.checkInId,
        ds,
        {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        }
      )
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/AdjustCheckInCheckOut.vue